import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {useCallback} from 'react';
import {useSessionGender} from '../../../shared-deprecated/sessionGender';
import {DiscountType} from '../enums/DiscountType';

export const useGetGenderBanner = () => {
  const {gender} = useSessionGender();

  return useCallback(
    (activeDiscount: GetDiscountsResponse_Discount) => {
      if (
        activeDiscount.discount?.$case !== DiscountType.priceReductionCampaign
      ) {
        return;
      }

      switch (gender) {
        case 'male':
          return activeDiscount.discount.priceReductionCampaign.maleTopBanner;
        default:
          return activeDiscount.discount.priceReductionCampaign.femaleTopBanner;
      }
    },
    [gender],
  );
};
